import Gallery from "./gallery";
import {useTranslation} from "react-i18next";
import logo from "../../../assets/images/mariposaEB_logo_no_background.png";
import {API_URL} from "../../../constants/constants";
import {Category} from "../../../interfaces/interfaces";
import {useState} from "react";

export const CollectionGallery = ({ props }: {
    props: {
        category: Category;
        collections: any;
        loading: boolean;
    }
}) => {
    const {t} = useTranslation()
    const collectionsArray = Object.values(props.collections)
        .filter(
            (collection: any) =>
                collection.products &&
                collection.products.length > 0
        );

    if (props.loading) {
        return (
            <div className="photo-collections-container">
                <p>{t("gallery.loading")}</p>
            </div>
        );
    }

    if (collectionsArray.length === 0) {
        return (
            <div className="photo-collections-container">
                <h2>
                    {t("gallery.no-products-in")}{" "}
                    {t(
                        `menu.${props.category.name.toLowerCase()}`,
                        { defaultValue: props.category.name }
                    )}
                </h2>
            </div>
        );

    }

    return (
        <div>
            <div className="photo-collection-main-container"></div>

            <div className="photo-collections-container">
                {collectionsArray.map((collection: any) => (
                    <CollectionItem
                        key={collection.name}
                        props={{
                            collection: collection,
                            titleImageHeight: 200,
                            galleryImagesHeight: 250,
                        }}
                    />
                ))}
            </div>
        </div>
    );
};


const CollectionItem = ({ props } : {
    props: {
        collection: any;
        titleImageHeight: number;
        galleryImagesHeight: number;
    }
})=> {
    const [open, setOpen] = useState(true);

    if (props.collection.products.length === 0) { return null;
    } else return (

        <div className="photo-collection-item-container">
            <div className="photo-collection-item">
                <img src={props.collection.cover_image ? `${API_URL}${props.collection.cover_image}` : logo}
                     alt={props.collection.name}
                     height={props.titleImageHeight} />
                <h2>{props.collection.name}</h2>
                <button className={`arrow ${open ? 'arrow--down' : 'arrow--right'}`}
                        onClick={() => setOpen(o => !o)} />
            </div>
            {open && (<Gallery
                props={{ photos_collection: props.collection,
                    gallery_images_height: props.galleryImagesHeight }}
                />
            )}
        </div>
    );
};
